import mixins from 'vue-typed-mixins';
import { RouteConfig } from 'vue-router';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 企業ユーザーMixin from '@/entries/user/mixins/企業ユーザーMixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';

import UserApiUtility from '@/classes/common/UserApiUtility';

interface AsideClass {
  asideLink?: boolean;
  asideNoLink?: boolean;
  asideNow?: boolean;
}
interface Menu {
  label: string;
  route: RouteConfig;
  asideClass?: AsideClass;
}
const ASIDE_LINK = { asideLink: true };
const ASIDE_NO_LINK = { asideNoLink: true };

export default mixins(RoutesMixin, 企業ユーザーMixin, 事業所Mixin).extend({
  name: 'Authorized',

  data(): {
    initialMenus: Menu[];
  } {
    return {
      initialMenus: [],
    };
  },

  computed: {
    menus(): Menu[] {
      return this.initialMenus.map((m) => {
        let asideClass: AsideClass = { asideNow: true };
        // 現在のルートに応じてclassを設定
        if (this.currentRouteName !== m.route.name) {
          switch (this.currentRouteName) {
            case this.routes.事業所List.name:
              asideClass = ASIDE_NO_LINK;
              break;
            case this.routes.勘定科目.name:
            case this.routes.部門.name:
            case this.routes.計画書.name:
              asideClass = [this.routes.取込, this.routes.分析, this.routes.計画, this.routes.モニタリング].includes(
                m.route
              )
                ? ASIDE_NO_LINK
                : ASIDE_LINK;
              break;
            case this.routes.取込.name:
            case this.routes.分析.name:
            case this.routes.計画.name:
            case this.routes.モニタリング.name:
              asideClass = ASIDE_LINK;
              break;
          }
        }
        // 担当者ログインの時は「事業所の設定」「勘定科目の設定」「部門の設定」選択不可
        if (this.is担当者 && [this.routes.事業所List, this.routes.勘定科目, this.routes.部門].includes(m.route)) {
          asideClass = ASIDE_NO_LINK;
        }
        return {
          ...m,
          asideClass,
        };
      });
    },
    currentRouteName(): string {
      if (this.$route.name === undefined || this.$route.name === null) return '';
      switch (this.$route.name) {
        case this.routes.ライセンス.name:
        case this.routes.事業所Create.name:
        case this.routes.事業所Edit.name:
          return this.routes.事業所List.name!;
        default:
          return this.$route.name;
      }
    },
    loginUserLabel(): string {
      if (this.事業所 === null) return '';
      return this.is担当者
        ? `${this.事業所.c担当者名} / ${this.事業所.c事業所名}`
        : `${this.me.cユーザー名} / ${this.me.c企業名}`;
    },
  },

  created(): void {
    this.setMe();
    this.initialMenus = [
      {
        label: '事業所の設定',
        route: this.routes.事業所List,
      },
      {
        label: '勘定科目の設定',
        route: this.routes.勘定科目,
      },
      {
        label: '部門の設定',
        route: this.routes.部門,
      },
      {
        label: '計画書データの作成・比較',
        route: this.routes.計画書,
      },
      {
        label: '過去データの取込',
        route: this.routes.取込,
      },
      {
        label: '現状分析',
        route: this.routes.分析,
      },
      {
        label: '計画作成',
        route: this.routes.計画,
      },
      {
        label: 'モニタリング',
        route: this.routes.モニタリング,
      },
    ];
  },

  methods: {
    logout(): void {
      this.clearMe();
      UserApiUtility.removeToken();
      this.$router.push(this.routes.Login);
    },
    async pushMenuRoute(menu: Menu): Promise<void> {
      if (this.$route.name === menu.route.name) return;
      if (menu.route.name !== this.routes.事業所List.name) await this.update事業所MenuLog();
      this.$router.push({
        name: menu.route.name,
        params: this.$route.params,
      });
    },
  },
});
